"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selectable = void 0;
var AudioCategory = require("../Audio/AudioCategory");
var AudioToken_1 = require("../Audio/AudioToken");
var Topics = require("../Data/Topics");
var OutlineFilter_1 = require("../Filters/OutlineFilter");
var InputUtils = require("../Input/InputUtils");
var PixiUtils = require("../Utils/PixiUtils");
var RectUtils = require("../Utils/RectUtils");
/**
 * Selectable
 */
var Selectable = /** @class */ (function (_super) {
    __extends(Selectable, _super);
    function Selectable() {
        var _this = _super.call(this) || this;
        _this._isFocussed = false;
        _this._isSelected = false;
        _this._visuals = new PIXI.Container();
        _this.addChild(_this._visuals);
        _this._outlineFilter = new OutlineFilter_1.OutlineFilter();
        _this._outlineFilter.uniforms.thickness = [0.025, 0.025];
        _this._outlineFilter.uniforms.outlineColor = [70 / 255, 130 / 255, 210 / 255, 1];
        _this._outlineFilter.uniforms.filterClamp = [0, 0, 1, 1];
        _this.onSelected = new Array();
        _this.onDeselected = new Array();
        _this.on(InputUtils.Events.POINTER_OVER, _this.onPointerOver);
        _this.on(InputUtils.Events.POINTER_DOWN, _this.onPointerDown);
        _this.on(InputUtils.Events.POINTER_UP, _this.onPointerUp);
        _this.on(InputUtils.Events.POINTER_UP_OUTSIDE, _this.onPointerUpOutside);
        _this.on(InputUtils.Events.POINTER_OUT, _this.onPointerOut);
        _this.interactive = true;
        _this.buttonMode = true;
        _this.hitArea = new PIXI.Rectangle(-25, -25, 50, 50);
        return _this;
    }
    Object.defineProperty(Selectable.prototype, "isSelected", {
        /**
         * Gets whether is selected
         */
        get: function () {
            return this._isSelected;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Selects selectable
     */
    Selectable.prototype.select = function () {
        this._isSelected = true;
        this._visuals.filters = [this._outlineFilter];
        for (var i = 0; i < this.onSelected.length; ++i) {
            this.onSelected[i](this);
        }
    };
    /**
     * Deselects selectable
     */
    Selectable.prototype.deselect = function () {
        this._isSelected = false;
        this._visuals.filters = [];
        for (var i = 0; i < this.onDeselected.length; ++i) {
            this.onDeselected[i](this);
        }
    };
    /**
     * Toggles selected
     */
    Selectable.prototype.toggleSelected = function () {
        if (this.isSelected) {
            this.deselect();
        }
        else {
            this.select();
        }
    };
    /**
     * onFocusBegin
     */
    Selectable.prototype.onFocusBegin = function () {
        this.playHoverVo();
    };
    /**
     * onFocusEnd
     */
    Selectable.prototype.onFocusEnd = function () {
        // unused
    };
    /**
     * onFocusActivated
     */
    Selectable.prototype.onFocusActivated = function () {
        this.toggleSelected();
        this.playClickedSFX();
    };
    /**
     * Gets focus position
     * @returns PIXI.Point
     */
    Selectable.prototype.getFocusPosition = function () {
        if (this.hitArea instanceof PIXI.Rectangle) {
            return new PIXI.Point().copyFrom(this.toGlobal(RectUtils.center(this.hitArea)));
        }
        else {
            return this.getGlobalPosition();
        }
    };
    /**
     * Gets focus size
     * @returns PIXI.Point
     */
    Selectable.prototype.getFocusSize = function () {
        var bounds;
        if (this.hitArea instanceof PIXI.Rectangle) {
            bounds = PixiUtils.getGlobalBounds(this, this.hitArea.clone());
        }
        else {
            bounds = PixiUtils.getGlobalBounds(this);
        }
        return RectUtils.size(bounds);
    };
    /**
     * Plays hover vo
     */
    Selectable.prototype.playHoverVo = function () {
        if (this._hoverVo !== undefined) {
            PubSub.publishSync(Topics.PLAY_AUDIO, new AudioToken_1.AudioToken(this._hoverVo, 1, false, AudioCategory.VO.toString()));
        }
    };
    /**
     * playClickedSFX
     */
    Selectable.prototype.playClickedSFX = function () {
        if (this._clickedSfx !== undefined) {
            PubSub.publishSync(Topics.PLAY_AUDIO, new AudioToken_1.AudioToken(this._clickedSfx, 1, false, AudioCategory.SFX.toString()));
        }
    };
    /**
     * onPointerOver
     */
    Selectable.prototype.onPointerOver = function (pEvent) {
        this._visuals.scale.set(1.05);
        this.playHoverVo();
    };
    /**
     * onPointerDown
     */
    Selectable.prototype.onPointerDown = function (pEvent) {
        this._eventData = pEvent.data;
        this._visuals.scale.set(0.95);
    };
    /**
     * onPointerUp
     */
    Selectable.prototype.onPointerUp = function (pEvent) {
        if (this._eventData !== undefined && this._eventData.identifier === pEvent.data.identifier) {
            this.toggleSelected();
            this._eventData = undefined;
            this._visuals.scale.set(1.05);
            this.playClickedSFX();
        }
    };
    /**
     * onPointerUpOutside
     */
    Selectable.prototype.onPointerUpOutside = function (pEvent) {
        this._eventData = undefined;
    };
    /**
     * onPointerOut
     */
    Selectable.prototype.onPointerOut = function (pEvent) {
        this._visuals.scale.set(1.0);
    };
    return Selectable;
}(PIXI.Container));
exports.Selectable = Selectable;
//# sourceMappingURL=Selectable.js.map